import BRS from 'assets/innvolight/OCT-Images/BRS.jpg'
import CalcifiedNodule from 'assets/innvolight/OCT-Images/Calcified-Nodule.jpg'
import CholesterolCrystals from 'assets/innvolight/OCT-Images/Cholesterol-Crystals.jpg'
import DCBPolymer from 'assets/innvolight/OCT-Images/DCB-Polymer.jpg'
import DES from 'assets/innvolight/OCT-Images/DES.jpg'
import Dissection from 'assets/innvolight/OCT-Images/Dissection.jpg'
import MacrophageInfiltration from 'assets/innvolight/OCT-Images/Macrophage-Infiltration.jpg'
import MicroChannels from 'assets/innvolight/OCT-Images/Micro-Channels.jpg'
import PlaqueErosion from 'assets/innvolight/OCT-Images/Plaque-Erosion.jpg'
import PlaqueRupture from 'assets/innvolight/OCT-Images/Plaque-Rupture.jpg'
import RedThrombosis from 'assets/innvolight/OCT-Images/Red-Thrombosis.jpg'
import WovenBloodVessel from 'assets/innvolight/OCT-Images/Woven-Blood-Vessel.jpg'

const Data = [
  {
    icon: DES,
    text: 'DES',
  },
  {
    icon: BRS,
    text: 'BRS',
  },
  {
    icon: DCBPolymer,
    text: 'DCB Polymer',
  },
  {
    icon: Dissection,
    text: 'Dissection',
  },
  {
    icon: WovenBloodVessel,
    text: 'Woven Blood Vessel',
  },
  {
    icon: MicroChannels,
    text: 'Micro Channels',
  },
  {
    icon: MacrophageInfiltration,
    text: 'Macrophage Infiltration',
  },
  {
    icon: CholesterolCrystals,
    text: 'Cholesterol Crystals',
  },
  {
    icon: RedThrombosis,
    text: 'Red Thrombosis',
  },
  {
    icon: PlaqueRupture,
    text: 'Plaque Rupture',
  },
  {
    icon: PlaqueErosion,
    text: 'Plaque Erosion',
  },
  {
    icon: CalcifiedNodule,
    text: 'Calcified Nodule',
  },
]

export default function OctImages() {
  return (
    <div className="relative h-auto bg-center bg-slate-50">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div>
          <h3 className="text-2xl font-bold text-left text-black sm:text-2xl md:text-3xl gsap-opacity-trans-appear">
            <span className="text-orange">OCT</span> Images
          </h3>
        </div>
        <div className="grid w-full max-w-6xl grid-cols-2 gap-4 mx-auto mt-10 sm:gap-8 lg:gap-10 md:grid-cols-3 gsap-stagger-bounce-parent">
          {/* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */}
          {Data.map((val, ind) => {
            return (
              <div
                className="flex flex-col justify-center gap-0 p-2 border shadow-[0_7px_29px_0px_rgba(100,100,111,0.2)] gsap-stagger-bounce border-Green-100"
                key={ind}
              >
                <div className="w-full h-full">
                  <img
                    src={val.icon}
                    alt=""
                    className="object-contain w-full h-full"
                  />
                </div>
                <p className="mt-2 font-bold text-center text-[12px] sm:text-lg md:text-sm lg:text-xl xl:text-2xl">
                  {val.text}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
